// extracted by mini-css-extract-plugin
export default {"marginBtn":"NewEventForm_marginBtn__KN-qW","buttonBlock":"NewEventForm_buttonBlock__8Scpi"};